<template>
  <v-list-item @click="open">
    <v-list-item-avatar>
      <v-icon small color="secondary">fal fa-plus</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title class="secondary--text">語学資格を追加する</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action class="text-xs-right">
      <v-btn text :disabled="true"></v-btn>
    </v-list-item-action>
    <v-dialog scrollable v-model="config.status.active" max-width="600">
      <v-card>
        <v-card-title class="primary amber blue-grey--text text--darken-4">
          <span class="headline">語学資格の追加</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-row dense>
                <v-col cols="12" class="px-3">
                  <v-combobox
                    v-model="form.name"
                    label="資格名"
                    :rules="rules.name"
                    :items="getCertItems"
                  />
                </v-col>
                <v-col cols="12" class="px-3">
                  <v-text-field
                    v-model="form.score"
                    label="点数・級"
                    :rules="rules.score"
                  />
                </v-col>
                <v-col cols="12" class="px-3">
                  <v-text-field
                    v-model="printFormatedDate"
                    maxlength="30"
                    append-icon="fa fa-calendar-alt"
                    @click:append="datepick"
                    label="取得時期"
                  />
                  <v-dialog v-model="config.datepicker.date.status" max-width="290">
                    <v-date-picker
                      v-model="config.datepicker.date.data"
                      color="amber"
                      locale="ja"
                      :day-format="date => new Date(date).getUTCDate()"
                      @input="datepicked"></v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" class="px-3">
                  <v-text-field counter
                    v-model="form.note"
                    label="備考欄"
                    maxlength="50"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn text
            color="secondary"
            @click="close">閉じる</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="secondary"
            :disabled="!isValid"
            :loading="isLoading"
            @click="submit">追加する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-item>
</template>

<script>
export default {
  name: 'insert-modal',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        },
        datepicker: {
          date: {
            data: '',
            status: false
          }
        }
      },
      meta: {
        certs: [
          '英検',
          'TOEIC',
          'TOEFL',
          'TOEFL iBT',
          'IELTS'
        ]
      },
      form: {
        name: '',
        score: '',
        date: '',
        note: ''
      },
      rules: {
        name: [
          v => !!v || '必須項目です'
        ],
        score: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this, 'form', {
        valid: true,
        name: '',
        score: '',
        date: '',
        note: ''
      })
    },
    open: function () {
      this.init()
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'about/insert/meta', {
            cid: this.$route.params.id,
            mtype: 'about.cert',
            form: this.form
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('emit', {
                action: 'insert',
                data: {
                  type: 'certs',
                  resolve: res.data.data
                }
              })
            }
            this.$set(this.config.status, 'loading', false)
            this.$set(this.config.status, 'active', false)
          })
        })
      }
    },
    datepick: function () {
      if (this.form.date.split('-').filter(it => isFinite(it)).length === 3) {
        this.$set(this.config.datepicker.date, 'data', this.form.date)
      }
      this.$set(this.config.datepicker.date, 'status', true)
    },
    datepicked: function () {
      this.$set(this.form, 'date', this.config.datepicker.date.data)
      this.$set(this.config.datepicker.date, 'status', false)
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    printFormatedDate: {
      get: function () {
        if (this.form && this.form.date) {
          return (
            this.form.date.split('-').filter(it => isFinite(it)).length === 3
          ) ? this.$moment(this.form.date).format('YYYY/MM/DD') : this.form.date
        } else {
          return ''
        }
      },
      set: function (newValue) {
        this.$set(this.form, 'date', newValue)
      }
    },
    getCertItems () {
      return this.meta.certs
    }
  }
}
</script>
